import React, { useState, useRef, useEffect } from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';

const EditableCodeHighlighter = (props) => {
  const {
    initialCode,
    onChange,
    style,
  } = props;
  console.log('initialCode', initialCode)
  const [code, setCode] = useState(initialCode);
  const [isEditing, setIsEditing] = useState(false);
  const textareaRef = useRef(null);
  const preRef = useRef(null);

  const handleCodeChange = (event) => {
    const newCode = event.target.value
    setCode(newCode);
    onChange(newCode);
  };

  const handleTab = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      const target = e.target;
      const start = target.selectionStart;
      const end = target.selectionEnd;

      // Insert tab at cursor position
      const newCode = code.substring(0, start) + '    ' + code.substring(end);
      setCode(newCode);
      onChange(newCode);

      // Move cursor after tab
      setTimeout(() => {
        target.selectionStart = target.selectionEnd = start + 4;
      }, 0);
    }
  };
  useEffect(() => {
    if (initialCode) {
      setCode(initialCode);
    }
  }, [initialCode])

  return (
    <div className="relative group rounded-lg overflow-hidden">
      {isEditing ? (
        <div className="relative">
          {/* Hidden syntax highlighter to maintain styles */}
          <div className="invisible h-0 overflow-hidden">
            <SyntaxHighlighter
              {...props}
              ref={preRef}
            >
              {code || ' '}
            </SyntaxHighlighter>
          </div>
          
          {/* Editable textarea */}
          <textarea
            ref={textareaRef}
            value={code}
            onChange={handleCodeChange}
            onKeyDown={handleTab}
            className="w-full h-full min-h-[150px] border-0 font-mono text-inherit bg-transparent focus:outline-none resize-y whitespace-pre"
            style={{
              fontFamily: 'monaco, Consolas, monospace',
              caretColor: style.hljs?.color || '#fff',
              color: style.hljs?.color || '#fff',
              backgroundColor: style.hljs?.background,
              padding: style.hljs?.padding,
            }}
            spellCheck="false"
            autoComplete="off"
            onBlur={() => setIsEditing(false)}
            autoFocus
          />
        </div>
      ) : (
        <div onClick={() => setIsEditing(true)} className="cursor-text">
          <SyntaxHighlighter
            {...props}
            ref={preRef}
          >
            { code }
          </SyntaxHighlighter>
        </div>
      )}
      
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={() => setIsEditing(!isEditing)}
          className="px-3 py-1 text-xs font-medium text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-800 rounded border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        >
          {isEditing ? 'Preview' : 'Edit'}
        </button>
      </div>
    </div>
  );
};

export default EditableCodeHighlighter;
